import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_icon = _resolveComponent("oxd-icon")!

  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(_ctx.classes),
    style: _normalizeStyle(_ctx.style)
  }, [
    _renderSlot(_ctx.$slots, "icon", {}, () => [
      (_ctx.iconName)
        ? (_openBlock(), _createBlock(_component_oxd_icon, {
            key: 0,
            name: _ctx.iconName,
            class: "oxd-button-icon"
          }, null, 8, ["name"]))
        : _createCommentVNode("", true)
    ], true),
    _createTextVNode(" " + _toDisplayString(_ctx.label) + " ", 1),
    _renderSlot(_ctx.$slots, "iconRight", {}, () => [
      (_ctx.iconRightName)
        ? (_openBlock(), _createBlock(_component_oxd_icon, {
            key: 0,
            name: _ctx.iconRightName,
            class: "oxd-button-icon"
          }, null, 8, ["name"]))
        : _createCommentVNode("", true)
    ], true)
  ], 6))
}